export const UX_WRITING = {
    REGISTER_DATASET: 'New dataset',
    STEP_ONE_TITLE: 'Name your dataset',
    STEP_TWO_TITLE: 'Specify data properties',
    STEP_THREE_TITLE: 'Define the data schema',
    STEP_FOUR_TITLE: 'Configure data ingestion'
}
